import * as React from "react";
import { Card } from "antd";
import { isApex, isInternalDomain } from "../../../../services/utils";
import { CardContent } from "../../../../components/antd/card/CardContent";
import { CardTitle } from "../../../../components/antd/card/CardTitle";
import { formSet, formSetValue, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { FormItem } from "../../../../components/antd/form/FormItem";
import { FormLabel } from "../../../../components/antd/form/FormLabel";
import { FormItemValue } from "../../../../components/antd/form/FormItemValue";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { store } from "../../../../store";
import { useDebounce } from "../../../../components/table/useDebounce";
import { Ownership } from "../ownership";
import { CpErrorWarningArrayIcon } from "../../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";

export const Name: React.FC = () => {
  const { id } = useCpFormContext();
  const draftType = useCpFormValue(`meta.draftType`);
  const isEdit = draftType === "edit";
  const name = useCpFormValue("advanced.name");

  const [debouncedName, setDebouncedName] = useDebounce(name, 300);
  React.useEffect(() => {
    setDebouncedName(name);
  }, [name]);
  React.useEffect(() => {
    const form = store.getState().form.instances[id];
    const onBlurCounter = form.meta.onBlurCounter;
    formSet(id, `meta.onBlurCounter`, onBlurCounter + 1);
  }, [debouncedName]);

  const isDomainApex = React.useMemo(() => {
    return isApex(name);
  }, [name]);
  const isInternal = React.useMemo(() => isInternalDomain(name), [name]);

  React.useEffect(() => {
    if (isDomainApex || isInternal) {
      formSetValue(id, "advanced.spec.dnsMode", "cname");
    }
  }, [isDomainApex, isInternal]);

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container" data-section-id={"name"}>
        <Card>
          <CardTitle>
            Domain Name
            <CpErrorWarningArrayIcon names={[`advanced.name`]} />
          </CardTitle>
          <CardContent>
            {isEdit ? (
              <FormItem>
                <FormLabel>Domain</FormLabel>
                <FormItemValue>{name}</FormItemValue>
              </FormItem>
            ) : (
              <CpFormItem>
                <CpLabel name="advanced.name" />
                <CpInput name="advanced.name" style={{ maxWidth: 600 }} />
                <CpErrorWarning name="advanced.name" />
              </CpFormItem>
            )}
            <Ownership />
          </CardContent>
        </Card>
      </div>
    </>
  );
};
